var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_718)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.0873V58.9127C16 61.9985 18.4624 64.5 21.5 64.5H58.5C61.5376 64.5 64 61.9985 64 58.9127V15.2025C64 13.71 63.4122 12.2796 62.3677 11.2301L53.2957 2.11483C52.266 1.08026 50.8762 0.5 49.428 0.5H21.5C18.4624 0.5 16 3.00152 16 6.0873ZM19.5 58.9127V6.0873C19.5 4.9652 20.3954 4.05556 21.5 4.05556H48.75V16.246C48.75 18.35 50.4289 20.0556 52.5 20.0556H60.5V58.9127C60.5 60.0348 59.6046 60.9444 58.5 60.9444H21.5C20.3954 60.9444 19.5 60.0348 19.5 58.9127ZM60.5 16.5V15.2025C60.5 14.6598 60.2863 14.1396 59.9064 13.758L52.25 6.06509V16.246C52.25 16.3863 52.3619 16.5 52.5 16.5H60.5Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 26.75C41 25.7835 41.7835 25 42.75 25H54.25C55.2165 25 56 25.7835 56 26.75C56 27.7165 55.2165 28.5 54.25 28.5H42.75C41.7835 28.5 41 27.7165 41 26.75Z",
    fill: "#6BB3EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 34.75C41 33.7835 41.7835 33 42.75 33H54.25C55.2165 33 56 33.7835 56 34.75C56 35.7165 55.2165 36.5 54.25 36.5H42.75C41.7835 36.5 41 35.7165 41 34.75Z",
    fill: "#508FD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 42.75C41 41.7835 41.7835 41 42.75 41H54.25C55.2165 41 56 41.7835 56 42.75C56 43.7165 55.2165 44.5 54.25 44.5H42.75C41.7835 44.5 41 43.7165 41 42.75Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 17.3431 1.34315 16 3 16H33C34.6569 16 36 17.3431 36 19V49C36 50.6569 34.6569 52 33 52H3C1.34315 52 0 50.6569 0 49V19Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9238 43.543L7 23.5H10.4043L12.8652 37.2676L15.873 23.5H19.8242L22.709 37.5L25.2383 23.5H28.5742L24.582 43.543H21.0547L17.7734 28.5586L14.5195 43.543H10.9238Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.97e74ac1fc60db2ebeb3d9fa11971f68.svg";
export { ForwardRef as ReactComponent };